import { CalendarRange, Repeat, Clock, Timer } from "lucide-react";
import {
  formatSessionDateSpan,
  formatSessionSummary,
  formatSessionTiming,
  totalSessionHours,
} from "@/lib/ongoingProgrammes";

/** Date span, sessions, timing and total hours for a recurring programme item. */
export function SessionBreakdown({ item }: { item: any }) {
  const span = formatSessionDateSpan(item);
  const summary = formatSessionSummary(item);
  const timing = formatSessionTiming(item);
  const hours = totalSessionHours(item);
  if (!span && !summary && !timing && !hours) return null;
  return (
    <div className="rounded-lg border border-primary/20 bg-primary/5 p-4 space-y-1.5">
      {span && (
        <div className="flex items-center gap-2 text-sm">
          <CalendarRange className="h-3.5 w-3.5 text-primary flex-shrink-0" />
          <span className="font-medium">{span}</span>
        </div>
      )}
      {summary && (
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Repeat className="h-3.5 w-3.5 text-primary flex-shrink-0" />
          <span>{summary}</span>
        </div>
      )}
      {timing && (
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Clock className="h-3.5 w-3.5 text-primary flex-shrink-0" />
          <span>{timing}</span>
        </div>
      )}
      {hours && (
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Timer className="h-3.5 w-3.5 text-primary flex-shrink-0" />
          <span>{hours} hours in total</span>
        </div>
      )}
    </div>
  );
}
